var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 0.870605C8.60996 0.870605 8.31289 1.06865 8.18594 1.37334C8.05898 1.67803 8.13008 2.02588 8.36113 2.25947L9.4123 3.30811L5.11367 7.60928C4.79629 7.92666 4.79629 8.44209 5.11367 8.75947C5.43105 9.07686 5.94648 9.07686 6.26387 8.75947L10.5625 4.4583L11.6137 5.50947C11.8473 5.74307 12.1951 5.81162 12.4998 5.68467C12.8045 5.55771 13.0025 5.26318 13.0025 4.93311V1.68311C13.0025 1.23369 12.6395 0.870605 12.19 0.870605H8.9375ZM2.03125 1.68311C0.908984 1.68311 0 2.59209 0 3.71436V11.8394C0 12.9616 0.908984 13.8706 2.03125 13.8706H10.1562C11.2785 13.8706 12.1875 12.9616 12.1875 11.8394V8.99561C12.1875 8.54619 11.8244 8.18311 11.375 8.18311C10.9256 8.18311 10.5625 8.54619 10.5625 8.99561V11.8394C10.5625 12.0628 10.3797 12.2456 10.1562 12.2456H2.03125C1.80781 12.2456 1.625 12.0628 1.625 11.8394V3.71436C1.625 3.49092 1.80781 3.30811 2.03125 3.30811H4.875C5.32441 3.30811 5.6875 2.94502 5.6875 2.49561C5.6875 2.04619 5.32441 1.68311 4.875 1.68311H2.03125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.4ee7e3a4b32727b84b48fd80e948c269.svg";
export { ForwardRef as ReactComponent };